import { Card, Divider, Typography } from "antd";
import React from "react";
import BinTransitDashboard from "../../../components/Wash/BinTransitDashboard/BinTransitDashboard";
import "../../../styles/global-ui.css";

const WashBinTransitPage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Washing Center In-Transit
          </Typography.Title>

          <Typography.Text className="page-subtitle">
            Track bins currently moving to washing center
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <BinTransitDashboard />
      </Card>
    </div>
  );
};

export default WashBinTransitPage;